import axios from 'axios';

import {BASE_URL} from '../utils/config';

export const fetchReligiousPageBaseData = async (slug) => {
    try {
        const response = await axios.get(`${BASE_URL}/religious/get-base-data/${slug}`);
        console.log("(accountApis.js) Fetch Vyadeshwar Page Base Data Response: ", response);

        return response.data;
    } catch (error) {
        console.log("(accountApis.js) Error occurred while fetching vyadeshwar page base data: ", error);
    }
}
